import {EffortPicker} from "./EffortPicker";
import {PriorityPicker} from "./PriorityPicker";
import {AssigneePicker} from "./AssigneePicker";
import {TagPicker} from "./TagPicker";
import {PresetPicker, PresetSaver} from "./PresetPicker";
import MilestonePropPicker from "./MilestonePropPicker";
import SprintPropPicker from "./SprintPropPicker";
import DueDatePropPicker from "./DueDatePropPicker";
import {Box, Col} from "@cdx/ds";

const PropEdit = (props) => {
  const {
    card,
    onChange,
    isCreating,
    root,
    isWorkflowItem,
    presetId,
    onSetPresetId,
    createInQueue,
    project: passedProject,
  } = props;
  const project = isWorkflowItem ? passedProject : card.deck && card.deck.project;
  return (
    <Col px="12px" pt="12px" pb="32px" data-cdx-context="PropEdit">
      <AssigneePicker
        card={card}
        projects={project ? [project] : []}
        root={root}
        value={card.assignee}
        onChange={onChange}
        isCreating={isCreating}
        createInQueue={createInQueue}
      />
      {card.isDoc ? (
        <Box size={14} color="secondary" py="16px">
          Can't set effort or priority for Doc cards
        </Box>
      ) : (
        <>
          <PriorityPicker
            card={card}
            account={root.account}
            value={card.priority}
            onChange={onChange}
            root={root}
          />
          <EffortPicker
            account={root.account}
            card={card}
            value={card.effort}
            onChange={onChange}
          />
        </>
      )}
      {!isWorkflowItem && (root.account.sprintsEnabled || card.sprint) && (
        <SprintPropPicker card={card} onChange={onChange} project={project} root={root} />
      )}
      {!isWorkflowItem && (root.account.milestonesEnabled || card.milestone) && (
        <MilestonePropPicker card={card} onChange={onChange} project={project} root={root} />
      )}
      {!isWorkflowItem && (root.account.milestonesEnabled || card.dueDate) && (
        <DueDatePropPicker card={card} onChange={onChange} root={root} />
      )}
      {project ? (
        <TagPicker
          card={card}
          project={project}
          me={root.loggedInUser}
          value={card.masterTags}
          onChange={onChange}
          root={root}
        />
      ) : (
        <Col sp="12px" py="16px">
          <Box as="h3" size={12} bold color="primary" textTransform="uppercase">
            Project Tags
          </Box>
          <Box size={14} color="secondary">
            You can't pick project cards as this card is in no deck.
          </Box>
        </Col>
      )}
      {isWorkflowItem || card.isDoc ? null : isCreating ? (
        <PresetPicker
          card={card}
          root={root}
          onChange={onChange}
          presetId={presetId}
          onSetPresetId={onSetPresetId}
        />
      ) : (
        <PresetSaver root={root} card={card} />
      )}
    </Col>
  );
};

export default PropEdit;
